import { Navigate, useLocation } from 'react-router-dom'
import { loginPathFor } from '../utils/loginRedirect'
import { useAuth } from '../contexts/AuthContext'
import { isViewOnly } from '../utils/permissions'
import Topbar from './Topbar'

// Matches --topbar-h in index.css (shrinks on small screens).
const TOPBAR_HEIGHT = 'var(--topbar-h)'

export default function ProtectedRoute({
  children,
  blockViewOnly = false,
}: {
  children: React.ReactNode
  blockViewOnly?: boolean
}) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return null // or a loading spinner
  }

  if (!user) {
    return (
      <Navigate
        to={loginPathFor(location.pathname, location.search, location.hash)}
        replace
      />
    )
  }

  if (blockViewOnly && isViewOnly(user)) {
    return <Navigate to="/" replace />
  }

  return (
    <>
      <Topbar />
      <div style={{ paddingTop: TOPBAR_HEIGHT }}>
        {children}
      </div>
    </>
  )
}
